<template>
  <div class="p-3 border bg-white rounded h-100 position-relative">
    <div
      v-if="!loaded"
      class="spinner-border spinner-border-sm text-primary position-absolute"
      style="top: 1rem; right: 1rem;"
      role="status">
    </div>

    <strong class="d-block mb-1 text-primary">{{ filter.name }}</strong>

    <span v-if="loaded" class="text-secondary">
      {{ formattedValue }}
    </span>
    <span v-else class="text-muted small">
      {{ $t('ui.dataLoading') }}&hellip;
    </span>
  </div>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import orderStatuses from '@/data/order-statuses.js';

export default {
  name: 'segment-filter-readonly',
  props: {
    filter: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      filterOptions: [],
      parsedValue: null
    };
  },
  computed: {
    filterOptionsEndpoint() {
      const endpoints = {
        'source': {
          endpoint: '/sources/items',
          where: { return: 'get' }
        },
        'region': {
          endpoint: '/customers/regions/items',
          where: { return: 'get' }
        },
        'tags': {
          endpoint: '/customers/tags/items',
          where: { return: 'get' }
        },
        'category': {
          endpoint: '/categories/items',
          where: { return: 'get' }
        },
        'user': {
          endpoint: '/users/items',
          where: { return: 'get', type: ['admin', 'worker'] }
        }
      };

      return endpoints[this.filter.field] || null;
    },

    formattedValue() {
      const val = this.parsedValue;

      if (val === null || val === undefined || val === '') {
        return '-';
      }

      switch (this.filter.type) {
        case 'number_range':
        case 'date_range': {
          const from = val.from || '';
          const to = val.to || '';

          if (from && to) {
            return `${this.$t('ui.from')} ${from} ${this.$t('ui.to')} ${to}`;
          }

          if (from) {
            return `${this.$t('ui.from')} ${from}`;
          }

          if (to) {
            return `${this.$t('ui.to')} ${to}`;
          }

          return '-';
        }

        case 'days_ago':
          return `${val} ${this.$t('marketing.daysAgo')}`;

        case 'choice':
          if (this.filter.field === 'newsletter') {
            if (val === 'subscribed') {
              return this.$t('customer.newsletterStatus.subscribed');
            }
            return this.$t('customer.newsletterStatus.unsubscribed');
          }

          if (val) {
            return this.$t('ui.yes');
          }
          return this.$t('ui.no');


        case 'select':
        case 'multiselect': {
          if (this.filter.field === 'status') {
            const statusName = orderStatuses[this.$i18n.locale][val];
            return statusName || val;
          }

          if (this.filterOptions.length > 0) {
            if (Array.isArray(val)) {
              return val.map(id => {
                const option = this.filterOptions.find(opt => opt.id === id || opt.id === parseInt(id, 10));

                if (option) {
                  return option.name;
                }

                return id;
              }).join(', ');
            }
            const option = this.filterOptions.find(opt => opt.id === val || opt.id === parseInt(val, 10));

            if (option) {
              return option.name;
            }

            return val;
          }

          if (Array.isArray(val)) {
            return val.join(', ');
          }

          return val;
        }

        case 'text':
        default:
          return val;
      }
    }
  },
  mounted() {
    this.initFilter();
  },
  methods: {
    initFilter() {
      try {
        this.parsedValue = JSON.parse(this.filter.value);
      } catch (e) {
        this.parsedValue = this.filter.value;
      }

      if (this.filterOptionsEndpoint) {
        this.loaded = false;
        FormUtils.loadAdditionalData(this, {
          method: 'get',
          endpoint: this.filterOptionsEndpoint.endpoint,
          params: this.filterOptionsEndpoint.where,
          loadedKey: 'loaded',
          outputKey: 'filterOptions',
          errorKey: null,
        });
      } else {
        this.loaded = true;
      }
    }
  }
};
</script>
